/**
 * Event subtitle
 * 
 * @module event-subtitle
 * @version 1.0.0
 * @extends HTMLElement
 */
class newEventSubtitle extends HTMLElement {

    /**
     * Event subtitle web component
     * 
     * @constructor
     */
    constructor() {

        super();

        const intersectionObserver = this.dataset.IntersectionObserver;

        if(intersectionObserver == 'true') {
            
            const handleIntersection = (entries, observer) => {

                if (!entries[0].isIntersecting) return;
    
                // init the component
                this.initSubtitle();
    
                // Stop observing the component
                observer.unobserve(this);
            }
    
            // Start observing the component
            new IntersectionObserver(handleIntersection.bind(this)).observe(this);
        }
        else {
            // init the component
            this.initSubtitle();
        }
    }

    /**
     * Init subtitle label
     * 
     * @return {undefined}
     */
    initSubtitle() {

        const handleEventName = this.dataset.eventName;

        // Check the event name
        if(handleEventName) {

            let event = window.shopEvents[handleEventName];

            if (typeof event != 'undefined') {

                this.setSubtitle(event);
            }
        }
    }

    /**
     * Set subtitle label
     * 
     * @param {Object} event Current event data.
     * @return {undefined}
     */
    setSubtitle(event) {

        if (event.status == 'fixed') {
            return;
        }

        // Live status
        if (event.status == 'live') {
            // Check sub_status for special cases
            if (event.sub_status == 'ends-today') {
                this.classList.add("ends-today");
                this.innerHTML = "Ends Today";
                this.dataset.status = "ends";
            } else if (event.sub_status == 'last-two-days') {
                this.classList.add("now-live");
                this.innerHTML = "Last Two Days";
            } else {
                this.classList.add("now-live");
                this.innerHTML = "Now Live";
            }
        }

        // Extended status
        if (event.status == 'extended') {
            this.classList.add("ends-today");
            this.innerHTML = "Extended " + event.end_date_formatted;
            this.dataset.status = "extended";
        }

        // Early Access status
        if (event.status == 'early-access') {
            this.classList.add("early-access");
            this.dataset.status = "early-access";

            if (event.market != 'Online') {
                this.innerHTML = '<span>Now Live</span>';
            } else {
                this.innerHTML = `<span class="event-subtitle__opens-msg">Opens ${event.start_date_day_after_formatted}</span>
                <span class="event-subtitle__opens-msg members">
                <svg width="100" height="100" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                            <stop offset="0%" style="stop-color:#5dc40c;stop-opacity:1" />
                            <stop offset="100%" style="stop-color:#00aa9f;stop-opacity:1" />
                        </linearGradient>
                    </defs>
                    <polygon points="12,2 15,8 22,9 17,14 18,21 12,18 6,21 7,14 2,9 9,8" fill="url(#grad1)" />
                </svg>
                Members shop ${event.start_date_formatted}</span>`;
            }
        }
        
        // Coming Soon status
        if (event.status == 'coming-soon') {
            if (event.market != 'Online') {
                // Physical events - show opening date or weekday
                if (event.sub_status == 'opens-soon') {
                    this.innerHTML = '<span>Opens ' + event.start_date_weekday + '</span>';
                } else {
                    this.innerHTML = '<span>Opens ' + event.start_date_formatted + '</span>';
                }
            } else {
                // Online events - show both public and members dates
                if (event.sub_status == 'opens-soon') {
                    this.innerHTML = `<span class="event-subtitle__opens-msg">Opens ${event.start_date_day_after_weekday}</span>
                    <span class="event-subtitle__opens-msg members">
                    <svg width="100" height="100" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#5dc40c;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#00aa9f;stop-opacity:1" />
                            </linearGradient>
                        </defs>
                        <polygon points="12,2 15,8 22,9 17,14 18,21 12,18 6,21 7,14 2,9 9,8" fill="url(#grad1)" />
                    </svg>
                    Members shop ${event.start_date_weekday}</span>`;
                } else {
                    this.innerHTML = `<span class="event-subtitle__opens-msg">Opens ${event.start_date_day_after_formatted}</span>
                    <span class="event-subtitle__opens-msg members">
                    <svg width="100" height="100" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
                                <stop offset="0%" style="stop-color:#5dc40c;stop-opacity:1" />
                                <stop offset="100%" style="stop-color:#00aa9f;stop-opacity:1" />
                            </linearGradient>
                        </defs>
                        <polygon points="12,2 15,8 22,9 17,14 18,21 12,18 6,21 7,14 2,9 9,8" fill="url(#grad1)" />
                    </svg>
                    Members shop ${event.start_date_formatted}</span>`;
                }
            }
        }
        
    }

}

customElements.define('new-event-subtitle', newEventSubtitle);
